import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from '../style/styles';
import TranslationRevisionsTable from './TranslationRevisionsTable';
import {
    fetchTranslationRevisions,
    activeTranslationRevision,
    deleteBlockRevision
} from '../thunks';
import {
    fetchSites,
} from '../../sites/thunks';

class TranslationRevisionsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.handleApprovedRevision = this.handleApprovedRevision.bind(this);
        this.deleteBlockRevision = this.deleteBlockRevision.bind(this);
        this.handleClickOpenDialog = this.handleClickOpenDialog.bind(this);
        this.handleRequestCloseDialog = this.handleRequestCloseDialog.bind(this);
    }
    componentWillMount() {
        this.props.fetchTranslationRevisions(this.props.blockSiteTranslationId);
        this.props.fetchSites();
     }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleApprovedRevision = (blockSiteTranslationId, revisionId) => {
        this.props.activeTranslationRevision(blockSiteTranslationId, revisionId)
    };

    deleteBlockRevision = () => {
        alert(this.state.revisionId + ' deleted')
        //this.props.deleteBlockRevision(this.state.revisionId)
        this.setState({
            open: false,
            revisionId: null
        });
    }

    handleClickOpenDialog = (revisionId) => {
        this.setState({
            open: true,
            revisionId: revisionId
        });
    };

    handleRequestCloseDialog = () => {
        this.setState({
            open: false,
            revisionId: null
        });
    };

    getSiteName(options) {
        const optionName = options.map(option => option.id === this.props.blockSiteTranslation.site_id ? option.name : '')
        return optionName;
    }

    render() {
        return (
            this.props.loading !== true &&
            <TranslationRevisionsTable
                blockSiteTranslationId={this.props.blockSiteTranslationId}
                translationRevisions={this.props.translationRevisions}
                siteName={this.getSiteName(this.props.sites)}
                approvedRevision={this.props.approvedRevision}
                blockId={this.props.blockId}
                siteId={this.props.siteId}
                classes={this.props.classes}
                open={this.state.open}
                selectedOption={this.state.selectedOption}
                handleClickOpen={this.handleClickOpenDialog}
                handleSubmit={this.deleteBlockRevision}
                handleRequestClose={this.handleRequestCloseDialog}
                handleActive={this.handleApprovedRevision}
            />
        )
    }
}

const mapStateToProps = state => ({
    translationRevisions: state.blocks.allTranslationRevisions,
    sites: state.sites.all,
    approvedRevision: state.blocks.approvedTranslationRevision,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchTranslationRevisions,
    fetchSites,
    activeTranslationRevision,
    deleteBlockRevision
})(withStyles(styles)(TranslationRevisionsList));


// WEBPACK FOOTER //
// ./src/containers/blocks/translations/TranslationRevisionsList.jsx